
export default function AppObjectFieldObjectState({ field, value }) {
  console.log(`AppObjectFieldObjectState rendered: ${field.name}`)

  return (
    <div>
      {value}
    </div>
  )
}
